import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable } from "rxjs";
import { CoSignBillingDetails, CoSignDefaultUserObject, CoSignDetailsRequest, CoSignDocumentDetails, CoSignRequest, CptDetails } from "../interfaces/cosign.interface";
import { formatDate } from "@angular/common";
import { GenericResponse } from "../interfaces/generic-response.interface";

@Injectable({ providedIn: "root" })
export class CoSignerClient {
    endpoint = "co-sign";
    constructor(private httpClient: HttpClient) { }

    getCoSigners(facilityId: string | null, disciplineId: number,defaultUserObj:CoSignDefaultUserObject): Observable<any[]> {
        return this.httpClient.get<any[]>(
            `${environment.endpoint}/${this.endpoint}/get-cosigners`,
            {params:{
                facilityId:facilityId!,
                disciplineId:disciplineId,
                documentId:defaultUserObj?.documentId??0,
                patientId:defaultUserObj?.patientId??null,
                date:defaultUserObj?.date??new Date().toISOString()
            }}
        );
    }

    getCoSignersByFacility(facilityId: string | null): Observable<any[]> {
        return this.httpClient.get<any[]>(
            `${environment.endpoint}/${this.endpoint}/get-cosigners/facility/${facilityId}`
        );
    }

    getCoSignBillingDetails(request: CoSignDetailsRequest): Observable<GenericResponse<CoSignBillingDetails>> {
        let params = new HttpParams()
            .set('facilityId', request.facilityId)
            .set('cosignerId', request.cosignerId)
            .set('archivedOnly', request.archivedOnly);

        if (request.searchString?.trim()) {
            params = params.set('searchString', request.searchString);
        }

        return this.httpClient.get<GenericResponse<CoSignBillingDetails>>(
            `${environment.endpoint}/${this.endpoint}/get-cosign-billing-details`,
            {
                params
            }
        );
    }

    getCoSignDocumentDetails(request: CoSignDetailsRequest): Observable<GenericResponse<CoSignDocumentDetails>> {
        let params = new HttpParams()
            .set('facilityId', request.facilityId)
            .set('cosignerId', request.cosignerId)
            .set('archivedOnly', request.archivedOnly);

        if (request.searchString?.trim()) {
            params = params.set('searchString', request.searchString);
        }

        return this.httpClient.get<GenericResponse<CoSignDocumentDetails>>(
            `${environment.endpoint}/${this.endpoint}/get-cosign-documents`,
            {
                params
            }
        );
    }

    getCoSignBillingCPTdetails(disciplineId: number, patientId: string, date: Date, requestedById: string) {
        const formattedDate = formatDate(date, 'MM-dd-yyyy', 'en-US');
        return this.httpClient.get<CptDetails>(
            `${environment.endpoint}/${this.endpoint}/get-billing-cpt-details/${patientId}/${disciplineId}/${formattedDate}/${requestedById}`);
    }

    signBillingDetails(cosignBillingRequest: CoSignRequest): Observable<GenericResponse<void>> {
        return this.httpClient.put<GenericResponse<void>>(
            `${environment.endpoint}/${this.endpoint}/cosign-billing-details`,
            cosignBillingRequest
        );
    }

    signDocumentDetails(cosignDocuementRequest: CoSignRequest): Observable<GenericResponse<void>> {
        return this.httpClient.put<GenericResponse<void>>(
            `${environment.endpoint}/${this.endpoint}/cosign-document-details`,
            cosignDocuementRequest
        );
    }
}
